// Debounce a rapidly-changing value (e.g. a search box) so dependents — like the
// server-side users search — only react after the value has settled for `delayMs`.
// Returns the latest value that has been stable for the delay.

import { useEffect, useState } from "react"

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(handle)
  }, [value, delayMs])

  return debounced
}
